import { render, staticRenderFns } from "./FirstAccess.vue?vue&type=template&id=92836b6a&scoped=true&"
import script from "./FirstAccess.vue?vue&type=script&lang=js&"
export * from "./FirstAccess.vue?vue&type=script&lang=js&"
import style0 from "./FirstAccess.vue?vue&type=style&index=0&id=92836b6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92836b6a",
  null
  
)

export default component.exports